function videoBtnShareCopyToClipBoard() {
    const input = $('.js-video-share-link');
    input.select();
    document.execCommand('copy');
}

function videoInsertUrlToShareField() {
    const url = window.location.href;
    const input = $('.js-video-share-link');
    input.val(url);
}

runIfElementExist(videoInsertUrlToShareField, '.js-video-share-link');

$('.js-video-share-btn').on('click', function () {
    /* show message for 5 seconds */
    const copyLinkMessage = $('.js-copy-link-message');
    videoBtnShareCopyToClipBoard();
    copyLinkMessage.addClass('active');
    setTimeout(() => {
        copyLinkMessage.removeClass('active');
    }, 5000);
});
